import jsQR from "jsqr"
// import logger from "@/helpers/logger"

export default {
    async startQRScanning(successCallback, completeCallback, dialog, videoLoadedCallback) {
        const unableToAccessCameraMsg = window.$msg.cameraAccessDenied;

        try {
            let self = this;

            if (self.scanQRTimeout) {
                return;
            }

            const options = await this.getCameraOptions();
            const option = options && options.length ? options[options.length - 1] : { facingMode: "environment" };
            // console.debug("Selected camera option", option);

            /* Ask for "environnement" (rear) camera if available (mobile), will fallback to only available otherwise (desktop).
                * User will be prompted if (s)he allows camera to be started */
            // navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" }, audio: false }).then(function (stream) {
            navigator.mediaDevices.getUserMedia({ video: option, audio: false }).then(function (stream) {
                if (videoLoadedCallback) {
                    videoLoadedCallback();
                }

                var video = document.getElementById("video-preview");
                video.srcObject = stream;
                video.setAttribute("playsinline", true); /* otherwise iOS safari starts fullscreen */
                video.play();

                self.scanQRTimeout = setTimeout(tick, 100);
            })
                .catch(function (error) {
                    dialog({ title: unableToAccessCameraMsg, message: error })

                    completeCallback()

                    // logger.logError("Browser QRScanner - getUserMedia - error callback", error)
                    // alert(error); /* User probably refused to grant access*/
                });

            let video = this.video = document.getElementById("video-preview");
            var qrCanvasElement = document.getElementById("qr-canvas");
            var qrCanvas = qrCanvasElement.getContext("2d");
            // var loadingMessage = document.getElementById("loadingMessage");

            function tick() {
                // loadingMessage.innerText = "Loading video..."

                if (video.readyState === video.HAVE_ENOUGH_DATA) {
                    // loadingMessage.hidden = true;

                    //These 2 lines are very important as it somehow increase QR detection
                    qrCanvasElement.height = video.videoHeight;
                    qrCanvasElement.width = video.videoWidth;

                    qrCanvas.drawImage(video, 0, 0, qrCanvasElement.width, qrCanvasElement.height);

                    var code = null;

                    //1. jsQR
                    var imageData = qrCanvas.getImageData(0, 0, qrCanvasElement.width, qrCanvasElement.height);

                    var codeData = jsQR(imageData.data, imageData.width, imageData.height, {
                        inversionAttempts: "dontInvert"
                    });

                    if (codeData && codeData.data) {
                        code = codeData.data;
                    }

                    //Allow rescanning the same barcode only after 1 second(s)
                    if (code) {
                        if (!self.scannedQRCodeTime || (new Date()).getTime() - self.scannedQRCodeTime.getTime() > 1000) {
                            self.scannedQRCodeTime = new Date();
                            successCallback(code);
                            completeCallback()
                        }
                    }
                }

                self.scanQRTimeout = setTimeout(tick, 100);
            }
        }
        catch (ex) {
            // logger.logError("Browser QRScanner - startQRScanning - exception", ex)

            let cameraAccessDeniedFriendlyMessage = window.$msg.suggessIosSafari;
            // let cameraAccessDeniedFriendlyMessage = "Your browser either does not have the permissions required to access the camera or it does not support WebRTC (Web Real-Time Communications). <br/><br/>Please grant your browser camera access or update it. Trying out different browsers might help too!"
            if (/getUserMedia/i.test(ex)) {
                dialog({ title: unableToAccessCameraMsg, message: cameraAccessDeniedFriendlyMessage })
            }
            else {
                dialog({ title: unableToAccessCameraMsg, message: ex })
            }

            completeCallback()
        }
    },
    getCameraOptions() {
        const promise = new Promise(function (resolve, reject) {
            var options = [];

            if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                try {
                    navigator.mediaDevices.enumerateDevices()
                        .then(function (devices) {
                            devices.forEach(function (device) {
                                if (device.kind === 'videoinput') {
                                    if (device.label.toLowerCase().search("back") > -1) {
                                        options.push({ deviceId: { exact: device.deviceId }, facingMode: 'environment' });
                                    }
                                }
                                // console.log("getCameraOption - " + device.kind + ": " + device.label + " id = " + device.deviceId);
                            });

                            resolve(options);
                        });
                }
                catch (e) {
                    console.log("getCameraOption exception", e);
                    resolve(options);
                }
            }
            else {
                console.log("getCameraOption failed - no navigator.mediaDevices.enumerateDevices");
                resolve(options);
            }
        });

        return promise;
    },
    stopQRScanning() {
        let self = this;

        if (self.scanQRTimeout) {
            clearTimeout(self.scanQRTimeout)
            self.scanQRTimeout = null;
        }

        if (this.video) {
            this.video.pause();
            this.video.src = "";
            if (this.video.srcObject) {
                this.video.srcObject.getVideoTracks().forEach(track => track.stop());
            }
        }
    },
    toggleTouchLight(on) {
    }
}